// extracted by mini-css-extract-plugin
export default {"container":"vehicles_container__CUYyd","inputContainer":"vehicles_inputContainer__FkPkL","listContainer":"vehicles_listContainer__t0CSn"};